import React from 'react';
import './Login.css';

import { PageTitle } from '../../../components';

import { FaUserAlt, FaEnvelope, FaLock } from 'react-icons/fa'; 
import { Link } from 'react-router-dom';
 
// 設定Cookies設定的彈出視窗

import { useState, useEffect } from 'react';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';
 
const Login = () => { 

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />      

      {/* Page Title */}
      <PageTitle title={'login'} page={'login'} />

      <section className='login'>

        {/* Login Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaUserAlt /></div>

          {/* Heading for the Login Form */}
          <h3>登入系統</h3> 

          {/* Email Input */}
          <div className='input-field'>
            <label htmlFor='email'><FaEnvelope /></label>
            <input type="email" name="email" placeholder="請輸入您的行動電話" id="email" className='box' />
          </div>

          {/* Password Input */}
          <div className='input-field'>
            <label htmlFor='password'><FaLock /></label> 
            <input type="password" name="password" placeholder="請輸入您的密碼" id="password" className='box' />
          </div>

          {/* Remember me and Forgot password */}
          <div className='info'>

            {/* Remember me Checkbox */}
            <div className='remember'>
              <input type="checkbox" name="remember" id="remember-me" />
              <label htmlFor="remember-me"> 保持登入 </label>
            </div>

            {/* Forgot password Link */}
            <div className='forgot'>
              <Link to='/forgot-pwd' className='link'>忘記密碼</Link>
            </div>

          </div>

          {/* Login Button */} 
          <button type='submit' name='submit' id='submit' className='btn'>登入</button>

          {/* Registration Link */}
          <p><span className="register-label"> 還沒有加入會員？</span> <Link to='/register' className='link'>註冊</Link></p>
      
        </form>

      </section> 
    </> 
  );
}

export default Login;
